import { useEffect, useRef, useState } from 'react'

import { EMPTY_LIST } from '../../../../../../constants/common'

import {
  getCanGoNextInPage,
  getCanGoNextToNextPage,
  getCanGoPrevInPage,
  getCanGoPrevToPreviousPage,
  getEdgeItemId,
  getHasNext,
  getHasPrevious,
  getItemIdAtIndex,
  getOneBasedCurrentIndex,
  getPreviewNavigationState,
} from './useRequestProfileTabEmailsThreadPreviewNavigation.utils'

export function useRequestProfileTabEmailsThreadPreviewNavigation({
  activeItem,
  items,
  pagination,
  setActiveItem,
  onGuardPreviewAction,
  onSetPagination,
}) {
  const pendingEdgeDirectionRef = useRef(0)

  const [edgeNavigationTarget, setEdgeNavigationTarget] = useState(null)

  const itemsList = items ?? EMPTY_LIST

  const navigationState = getPreviewNavigationState({
    activeItem,
    edgeNavigationTarget,
    items,
    itemsList,
    pagination,
  })

  const { currentIndex, indexInPage, page, totalCount } = navigationState

  useEffect(() => {
    const pendingEdgeDirection = pendingEdgeDirectionRef.current

    if (pendingEdgeDirection !== 0 && itemsList.length > 0) {
      pendingEdgeDirectionRef.current = 0

      setActiveItem(getEdgeItemId(itemsList, pendingEdgeDirection))
    }
  }, [items])

  function goToNeighbourPage(direction) {
    pendingEdgeDirectionRef.current = direction

    setEdgeNavigationTarget({
      itemsBeforeNavigation: items,
      targetIndex: currentIndex + direction,
    })

    onSetPagination({ ...pagination, page: page + direction })
  }

  function goToItemInPage(direction) {
    setActiveItem(getItemIdAtIndex(itemsList, indexInPage + direction))
  }

  function handlePrevious() {
    if (getCanGoPrevInPage(navigationState)) {
      onGuardPreviewAction(() => goToItemInPage(-1))
    } else if (getCanGoPrevToPreviousPage(navigationState)) {
      onGuardPreviewAction(() => goToNeighbourPage(-1))
    }
  }

  function handleNext() {
    if (getCanGoNextInPage(navigationState)) {
      onGuardPreviewAction(() => goToItemInPage(1))
    } else if (getCanGoNextToNextPage(navigationState)) {
      onGuardPreviewAction(() => goToNeighbourPage(1))
    }
  }

  return {
    currentIndex: getOneBasedCurrentIndex(navigationState),
    handleNext,
    handlePrevious,
    hasNext: getHasNext(navigationState),
    hasPrevious: getHasPrevious(navigationState),
    totalCount,
  }
}
